<template>
  <div id="customer-payment">
    <div class="col-heading">
      <h3 class>
        Enter payment details
      </h3>
    </div>
    <div v-if="declinedMessage !== null">
      <small class="text--error">Failed to take payment - {{ declinedMessage }}</small>
    </div>

    <iframe
        id="windcaveiframe"
        v-bind:src="sessionId"
        class="windcaveiframe form-group col-md-12 col-lg-10 col-xl-9 section__group"
        width="100%"
        height="500px"
        border="0"
        style="border: 0; margin: 0; padding: 15px"
      >
    </iframe>

  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'PaymentDetailsWindcave',
    props: ['disabled'],
    data () {
        return {
            termsAndConditionsAccepted: false,
            paymentSessionUpdating: false,
            loadedSession: false,
            declinedMessage: null,
        }
    },
    computed: {
        ...mapState({
            sessionId: state => state.booking.bookingReserveResponse.data.sessionId
        }),
        bookingResponse: {
            get () {
                return this.$store.state.booking.bookingConfirmResponse
            },
            async set (value) {
                await this.$store.dispatch('setBookingCreationResponse', value)
            }
        },
        bookingAttempted () {
            return this.bookingResponse !== null
        },
        bookingSuccessful () {
            return this.bookingAttempted && this.bookingResponse.success
        },
        paymentButtonDisabled () {
            return (
                !this.termsAndConditionsAccepted ||
                (this.paymentSessionUpdating && !this.bookingAttempted) ||
                (this.bookingAttempted && this.bookingSuccessful) ||
                this.disabled
            )
        },
        paymentSessionAvailable () {
            return this.loadedSession
        },
    },
    mounted() {
        var iframe = document.getElementById('windcaveiframe');
        var instance = this;
        instance.showControl = true;
        iframe.onload = function() {
            let canShow = false;
            if (!iframe.contentDocument) {
                canShow = true;
            }
            else {
                var html = iframe.contentDocument.body.innerHTML;
                var parser = new DOMParser();
                var temp = parser.parseFromString(html, "text/html").documentElement;
                var transDiv = temp.querySelector('#transId');
                if (transDiv) {
                    // Approved
                    instance.declinedMessage = null;
                    var transId = transDiv.innerText;
                    var cardDiv = temp.querySelector('#cardId');
                    var cardId = cardDiv.innerText;
                    canShow = true;
                    const paymentSession = {
                        sessionId: cardId,
                        merchant: 'Windcave'
                    }
                    instance.$store.dispatch('setPaymentSession', paymentSession)

                } else {
                    // Declined
                    var responseTextDiv = temp.querySelector('#responseText');
                    var responseText = responseTextDiv.innerText;
                    var newSessionIdDiv = temp.querySelector('#newSessionId');
                    var newSessionId = newSessionIdDiv.innerText;

                    instance.declinedMessage = responseText;
                    iframe.src = newSessionId;
                    instance.$toasted.error(responseText);
                }
            }

            if (canShow) {
                instance.showControl = true;
            } else {
                instance.showControl = false;
            }
        };
  },
}
</script>
